import React from "react";
import { EnvironmentOutlined } from "@ant-design/icons";
import styles from "./AddressMarker.less";

const AddressMarker = ({ color, label }) => (
  <div className={styles.marker}>
    <div className={styles.label}>{label}</div>
    <EnvironmentOutlined style={{ fontSize: 24, color, marginTop: 4 }} />
  </div>
);

export default AddressMarker;
